export default "__VITE_ASSET__f2bd5fd0__"